export default "/images/vendor/pannellum-react/es/pannellum/css/grabbing.svg?92ec62eb995e792480669b05b336d239";